export const pluralize = (count = 0, noun: string, suffix = 's'): string =>
  `${count} ${noun}${count === 1 ? '' : suffix}`

export const pluralizeWithoutCount = (
  count = 0,
  noun: string,
  suffix = 's'
): string => `${noun}${count === 1 ? '' : suffix}`
